import { Injectable, NgZone, OnDestroy, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { globalWindow } from 'src/shared/window-globals';

@Injectable()
export class FiveComponentRefService implements OnDestroy {
  followersUpdated = new Subject<{ discussionId: number, followers: any }>();

  readonly #ngZone = inject(NgZone);
  readonly #router = inject(Router);

  setFiveComponentRef(): void {
    globalWindow.fiveComponentRef = {
      routerLink: this.#routerLink,
      addRouterSub: this.#addRouterSub,
      currentAccountRoute: (): string => this.#router.url.split('/')[3],
    };
  }

  ngOnDestroy(): void {
    globalWindow.fiveComponentRef = null;
  }

  #routerLink = (path: string, skipLocationChange = false): void => {
    this.#ngZone.run(() => {
      this.#router.navigateByUrl(path, { skipLocationChange });
    });
  };

  #addRouterSub = (func: any): void => {
    this.#router.events.subscribe(func);
  };
}

export interface FiveComponentRef {
  routerLink: (path: string) => void;
  addRouterSub: (func: any) => void;
  currentAccountRoute?: () => string;
}
